import React from 'react';
import { Link } from 'react-router-dom';
import { FiAlertTriangle } from 'react-icons/fi';

const NotFoundPage = () => {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <FiAlertTriangle className="text-6xl text-red-500 mb-4" />
      <h1 className="text-3xl font-bold text-text-light dark:text-text-dark mb-2">
        404 - Page Not Found
      </h1>
      <p className="text-lg text-text-light/80 dark:text-text-dark/80 mb-6">
        Sorry, the page you are looking for does not exist.
      </p>
      <Link 
        to="/"
        className="inline-flex items-center px-6 py-3 bg-accent-light hover:bg-accent-dark dark:bg-accent-dark dark:hover:bg-accent-light text-white dark:text-black rounded-md transition duration-150 ease-in-out font-semibold"
      >
        Go Back to Home
      </Link>
    </div>
  );
};

export default NotFoundPage; 